import inbox_empty from "@assets/images/inbox_empty.png";
import LBox from "@components/LBox";
import LText from "@components/LText";
import { theme } from "@theme";
import { Image } from "react-native";

const Empty = () => {
  return (
    <LBox flexDirection="row" justifyContent="center" mt="l3">
      <LBox alignItems="center" flexDirection="column" maxWidth={284}>
        <Image
          resizeMode="cover"
          source={inbox_empty}
          style={{ height: 85, marginBottom: theme.spacing.s2, width: 83 }}
        />
        <LText mb="s2" variant="messageTitle">
          Your inbox is empty!
        </LText>
        <LText variant="messageBody">
          It looks like there&apos;s nothing here right now.{"\n"}When new updates
          arrive, you&apos;ll see them here.
        </LText>
      </LBox>
    </LBox>
  );
};

export default Empty;
